var exports = {
  "MY": "OAuthAuthorizePage.module__page___cjRTV0",
  "Un": "OAuthAuthorizePage.module__errorContainer___cjRTV0",
  "ow": "OAuthAuthorizePage.module__errorContent___cjRTV0",
  "JU": "OAuthAuthorizePage.module__errorTitle___cjRTV0",
  "kc": "OAuthAuthorizePage.module__errorText___cjRTV0",
  "d1": "OAuthAuthorizePage.module__heroCard___cjRTV0",
  "iC": "OAuthAuthorizePage.module__heroCopy___cjRTV0",
  "ZY": "OAuthAuthorizePage.module__heroTitle___cjRTV0",
  "fd": "OAuthAuthorizePage.module__heroDescription___cjRTV0",
  "$2": "OAuthAuthorizePage.module__cardGrid___cjRTV0",
  "Ql": "OAuthAuthorizePage.module__accountList___cjRTV0",
  "ts": "OAuthAuthorizePage.module__sectionDivider___cjRTV0",
  "nd": "OAuthAuthorizePage.module__panel___cjRTV0",
  "bV": "OAuthAuthorizePage.module__sectionHeader___cjRTV0",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___cjRTV0",
  "yV": "OAuthAuthorizePage.module__sectionDescription___cjRTV0",
  "s0": "OAuthAuthorizePage.module__inlineStatus___cjRTV0",
  "Jb": "OAuthAuthorizePage.module__scopeList___cjRTV0",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___cjRTV0",
  "C6": "OAuthAuthorizePage.module__permissionScroller___cjRTV0",
  "Mg": "OAuthAuthorizePage.module__permissionList___cjRTV0",
  "ce": "OAuthAuthorizePage.module__permissionRow___cjRTV0",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___cjRTV0",
  "rJ": "OAuthAuthorizePage.module__scopeRow___cjRTV0",
  "BB": "OAuthAuthorizePage.module__scopeHeading___cjRTV0",
  "OK": "OAuthAuthorizePage.module__scopeName___cjRTV0",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___cjRTV0",
  "Pp": "OAuthAuthorizePage.module__scopeChip___cjRTV0",
  "p$": "OAuthAuthorizePage.module__emptyState___cjRTV0",
  "uL": "OAuthAuthorizePage.module__caution___cjRTV0",
  "iB": "OAuthAuthorizePage.module__dangerNotice___cjRTV0",
  "mW": "OAuthAuthorizePage.module__successScreen___cjRTV0",
  "n7": "OAuthAuthorizePage.module__successIconCircle___cjRTV0",
  "FU": "OAuthAuthorizePage.module__successIcon___cjRTV0",
  "QK": "OAuthAuthorizePage.module__successTitle___cjRTV0",
  "s3": "OAuthAuthorizePage.module__successSubtitle___cjRTV0",
  "cs": "OAuthAuthorizePage.module__successAction___cjRTV0",
  "By": "OAuthAuthorizePage.module__guildOption___cjRTV0",
  "rZ": "OAuthAuthorizePage.module__guildValue___cjRTV0",
  "XN": "OAuthAuthorizePage.module__guildAvatar___cjRTV0",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___cjRTV0",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___cjRTV0",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___cjRTV0",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___cjRTV0",
  "A2": "OAuthAuthorizePage.module__actionSection___cjRTV0",
  "PJ": "OAuthAuthorizePage.module__footerText___cjRTV0",
  "o1": "OAuthAuthorizePage.module__actions___cjRTV0",
  "hP": "OAuthAuthorizePage.module__actionButton___cjRTV0",
};

module.exports = exports;
